/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum Bank131ApiDomainBank131ConstantsBank131ApiType {
    Bank131 = 0,
    SmartGLocal = 1,
    NUMBER_unknown_default_open_api = 11184809
}


export function instanceOfBank131ApiDomainBank131ConstantsBank131ApiType(value: any): boolean {
    for (const key in Bank131ApiDomainBank131ConstantsBank131ApiType) {
        if (Object.prototype.hasOwnProperty.call(Bank131ApiDomainBank131ConstantsBank131ApiType, key)) {
            if (Bank131ApiDomainBank131ConstantsBank131ApiType[key as keyof typeof Bank131ApiDomainBank131ConstantsBank131ApiType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function Bank131ApiDomainBank131ConstantsBank131ApiTypeFromJSON(json: any): Bank131ApiDomainBank131ConstantsBank131ApiType {
    return Bank131ApiDomainBank131ConstantsBank131ApiTypeFromJSONTyped(json, false);
}

export function Bank131ApiDomainBank131ConstantsBank131ApiTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Bank131ApiDomainBank131ConstantsBank131ApiType {
    return json as Bank131ApiDomainBank131ConstantsBank131ApiType;
}

export function Bank131ApiDomainBank131ConstantsBank131ApiTypeToJSON(value?: Bank131ApiDomainBank131ConstantsBank131ApiType | null): any {
    return value as any;
}

export function Bank131ApiDomainBank131ConstantsBank131ApiTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): Bank131ApiDomainBank131ConstantsBank131ApiType {
    return value as Bank131ApiDomainBank131ConstantsBank131ApiType;
}

